/**
 * Class-name joiner. Falsy entries drop out, which is what makes conditional
 * classes readable inline. Deliberately not `clsx`: this is nine lines and the
 * app does not need another dependency for it.
 */
export type ClassValue = string | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  let out = '';
  for (const value of values) {
    if (!value) continue;
    out = out ? `${out} ${value}` : value;
  }
  return out;
}
